// // language=none
// export const frameSelectionGrammar = `
// FrameSelection
// {
//     FrameSelector
//         = "@" (AllColumnsSelector|ColumnSelectors) (RowIndexExpr|RowRangeExpr|RowFilterExpr)?
//
//     AllColumnsSelector
//         = "*"
//
//     ColumnSelectors
//         = (ColumnName ","?)+
//
//     ColumnName (a column name)
//         = ident
//
//     RowRangeExpr (a row index expression)
//         = "[" rowIndexStart rowRangeSeparator rowIndexEnd "]"
//
//     RowIndexExpr (a row index expression)
//         = "[" rowIndex "]"
//
//     RowFilterExpr (a row filter expression)
//         = "[" jsExpr "]"
//
//     rowRangeSeparator
//         = "." "."
//
//     rowIndexStart
//         = digit+ | "first"
//
//     rowIndexEnd
//         = digit+ | "last" | "N" | "n"
//
//     rowIndex
//         = digit+ | "first" | "last" | "N" | "n" | "random"
//
//     jsExpr (a javascript expression)
//         = (alnum|exprChar|space)+
//
// 	exprChar
//         = "<" | ">" | "-" | "+" | "*" | "/" | "(" | ")" | "'" | "\\"" | "=" | "&" | "%" | "." | "!"
//
//     ident (an identifier)
//         = letter (alnum | "_" | "-")*
//
//     number (a number)
//         = digit* "." digit+  -- fraction
//         | digit+             -- whole
// }
// `;

// language=none
export const frameSelectionGrammar = `
FrameSelection
{
    FrameSelector
        = "@" (AllColumnsSelector|ColumnSelectors) (RowIndexExpr|RowRangeExpr|RowFilterExpr)?

    AllColumnsSelector
        = "*"

    ColumnSelectors
        = ( (NestedColumnName | ColumnName) ","?)+

    ColumnName (a column name)
        = ident

    NestedColumnName (a nested column name)
        = ident ("." ident)+

    RowRangeExpr (a row index expression)
        = "[" rowIndexStart rowRangeSeparator rowIndexEnd "]"

    RowIndexExpr (a row index expression)
        = "[" rowIndex "]"

    RowFilterExpr (a row filter expression)
        = "[" jsExpr "]"

    rowRangeSeparator
        = "." "."

    rowIndexStart
        = digit+ | "first"

    rowIndexEnd
        = digit+ | "last" | "N" | "n"

    rowIndex
        = digit+ | "first" | "last" | "N" | "n" | "random"

    jsExpr (a javascript expression)
        = (alnum|exprChar|space)+

	exprChar
        = "<" | ">" | "-" | "+" | "*" | "/" | "(" | ")" | "'" | "\\"" | "=" | "&" | "%" | "." | "!"

    ident (an identifier)
        = (letter | "_") (alnum | "_" | "-")*

    number (a number)
        = digit* "." digit+  -- fraction
        | digit+             -- whole
}
`;
